import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";
import defaultImage from "./../../assets/images/default-user-profile-image.jpg";
import MuiSearch from "../../components/MuiSearch";
import { toTitleCase } from "./../../resources/FormatString";

// MUI
import {
  TextField,
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AodIcon from "@mui/icons-material/Aod";
import { grey } from "@mui/material/colors";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import api from "../../api/api";
import moment from "moment";

// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// swal
import Swal from "sweetalert2";

// thunks
import {
  gettotalusersbyusertypeThunk,
  getdistrictsofstateThunk,
  getblocksofdistrictsThunk,
} from "./Users.Thunk";
import { searchtext_onchange, state_onchange } from "./Users.Slice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function UsersPage() {
  const dispatch = useDispatch();

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // -------------- Loader -----------------------
  const loading = useSelector((state) => state.UsersSlice.loading);
  // ---------------------------------------------

  // -------------- Card-item vertical menu ------
  const ITEM_HEIGHT = 48;
  const [selectedUser, setSelectedUser] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedUser({});
  };
  // ---------------------------------------------

  // --------------- clear all fields-------------
  const clear = () => {
    setUserid("");
    setUsername("");
    setFirstname("");
    setMiddlename("");
    setLastname("");
    setGuardianname("");
    setDob("");
    setPassword("");
    setContactnumber("");
    setManagertype("");
    setGender("");
    setQualification("");
    setState("");
    setDistrict("");
    setBlock("");
  };
  // ---------------------------------------------

  // ---------------- form input fields ----------
  const [userid, setUserid] = useState("");
  const [firstname, setFirstname] = useState("");
  const [middlename, setMiddlename] = useState("");
  const [lastname, setLastname] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [contactnumber, setContactnumber] = useState("");
  const [managertype, setManagertype] = useState("");
  const [gender, setGender] = useState("");
  const [qualification, setQualification] = useState("");
  const [state, setState] = useState("");
  const [stateid, setStateid] = useState("");
  const [statename, setStatename] = useState("");
  const [district, setDistrict] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [block, setBlock] = useState("");
  const [blockid, setBlockid] = useState("");
  const [blockname, setBlockname] = useState("");
  const [dob, setDob] = useState(null);
  const [guardianname, setGuardianname] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  // const [selectedDate, setSelectedDate] = useState(null);

  const districts = useSelector((state) => state.UsersSlice.districts);
  const blocks = useSelector((state) => state.UsersSlice.blocks);
  // ---------------------------------------------

  // ------------ dropdowns on change ------------
  const [usertype, setUsertype] = useState("manager");

  const usertype_select_onchange = (event) => {
    setUsertype(event.target.value);
  };
  const managertype_select_onchange = (event) => {
    setManagertype(event.target.value);
  };
  const gender_select_onchange = (event) => {
    setGender(event.target.value);
  };
  const qualification_select_onchange = (event) => {
    setQualification(event.target.value);
  };
  const state_select_onchange = (event) => {
    setState(event.target.value);
  };
  // const district_select_onchange = (event) => {
  //   //console.log("district_select_onchange--", event.target.value);
  //   setDistrict(event.target.value);
  // };
  const district_select_onchange = (event) => {
    setDistrict(event.target.value);
    const selectedDistrictId = event.target.value;
    // //console.log("Selected District ID:", selectedDistrictId);

    const selectedDistrict = districts.find(
      (district) => district._id === selectedDistrictId
    );
    if (selectedDistrict) {
      // //console.log("Selected District Name:", selectedDistrict.districtname);
      setDistrictName(selectedDistrict.districtname);
    }
  };
  const block_select_onchange = (event) => {
    setBlock(event.target.value);
    const selectedBlockId = event.target.value;
    // //console.log("Selected Block ID:", selectedBlockId);

    const selectedBlock = blocks.find((block) => block._id === selectedBlockId);
    if (selectedBlock) {
      // //console.log("Selected Block Name:", selectedBlock.blockname);
      setBlockname(selectedBlock.blockname);
    }
  };

  const openDatePickerModal = () => {
    setShowDatePicker(true);
  };

  const closeDatePickerModal = () => {
    setShowDatePicker(false);
  };

  const handleDateChange = (date) => {
    setDob(date);
    closeDatePickerModal();
  };

  // const handleSubmit = () => {
  //   // Handle the selected date
  //   //console.log("Selected Date:", selectedDate);
  //   closeDobModal();
  // };
  // ---------------------------------------------

  // ------------------- Search menu events ------
  const data = useSelector((state) => state.UsersSlice.data);
  const filteredData = useSelector((state) => state.UsersSlice.filteredData);
  //console.log("filteredData======>", filteredData);
  const [searchText, setSearchText] = useState("");

  const searchTextOnChange = (event) => {
    setSearchText(event.target.value);
    const searchResults = data.filter((item) =>
      item.username.toLowerCase().includes(event.target.value.toLowerCase())
    );
    dispatch(searchtext_onchange(searchResults));
  };
  // ---------------------------------------------

  // --------------------- data -----------------
  useEffect(() => {
    const load_data = () => {
      dispatch(gettotalusersbyusertypeThunk(usertype));
    };
    const load_districts = () => {
      if (state.length > 0) dispatch(getdistrictsofstateThunk(state));
      else dispatch(state_onchange());
    };
    const load_blocks = () => {
      if (state.length > 0)
        dispatch(
          getblocksofdistrictsThunk({ stateid: state, districtid: district })
        );
    };
    load_data();
    load_districts();
    load_blocks();
  }, [dispatch, usertype, state, district]);
  // ---------------------------------------------

  const create_user_button_click = () => {
    clear();
    setOpenModal(true);
  };
  const preview_user_button_click = (user) => {};

  const [showUpdate, setShowUpdate] = useState(false);
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };
  const [updateData, setUpdateData] = useState({
    username: firstname + " " + middlename + " " + lastname,
    firstname: "",
    middlename: "",
    lastname: "",
    managertype: "",
    userid: "",
    contactnumber: "",
    password: "",
    guardianname: "",
    gender: "",
    dob: parseInt(""),
    qualification: "",
    stateid: state,
    statename: "odisha",
    districtid: district,
    districtname: districtName,
    blockid: block,
    blockname: "",
  });
  //console.log("updateData===========>", updateData);
  const update_user_button_click = (user) => {
    setUpdateData({
      username: user.username,
      firstname: user.firstname,
      middlename: user.middlename,
      lastname: user.lastname,
      userid: user.userid,
      contactnumber: user.contactnumber,
      password: user.password,
      guardianname: user.guardianname,
      gender: user.gender,
      dob: user.dob,
      qualification: user.qualification,
      stateid: user.stateid,
      statename: user.statename,
      districtid: user.districtid,
      districtname: user.districtname,
      blockid: user.blockid,
      blockname: user.blockname,
    });
    setShowUpdate(true);
  };
  const delete_user_button_click = (user) => {};

  // -------------------- Modal -----------------------
  const [openModal, setOpenModal] = useState(false);
  // -----------------------------------------------------

  // ---------- modal cancle , save button click events -------------
  const modal_cancle_button_click = (params) => {
    setOpenModal(false);
  };
  // const UsrName = `{firstname} {middlename} {lastname}`;

  const modal_save_button_click = (params) => {
    const data = {
      username: firstname + " " + middlename + " " + lastname,
      firstname,
      middlename,
      lastname,
      managertype,
      userid,
      contactnumber,
      password,
      guardianname,
      gender,
      dob: parseInt(dob),
      qualification,
      stateid: state,
      statename: "odisha",
      districtid: district,
      districtname: districtName,
      blockid: block,
      blockname,
    };
    //console.log("data=========", data);
    api.post(`createNewManager`, data).then(
      (response) => {
        //console.log("response.data---", response.data);
        dispatch(gettotalusersbyusertypeThunk(usertype));
        // const params = { usertype };
        // dispatch(gettotalusersbyusertypeThunk(params));
        toast.success("Changes made successfully");
      },
      (err) => {
        //console.log(err);
        toast.error("Enter a valid Quiz");
      }
    );
    setOpenModal(false);
  };
  const handleUpdateChanges = () => {
    api.put(`updateManager`, updateData).then(
      (response) => {
        //console.log("response.updateData---", response.updateData);
        dispatch(gettotalusersbyusertypeThunk(usertype));
        toast.success("Changes made successfully");
      },
      (err) => {
        //console.log(err);
        // toast.error("Enter a valid Topic");
      }
    );
    setShowUpdate(false);
  };

  // -----------------------------------------------------

  // ---------- show user image ------------------
  function UserImage({ src }) {
    return (
      <img
        src={src}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultImage;
        }}
        alt=""
      />
    );
  }
  // ---------------------------------------------

  return (
    <>
      <MuiHeader header="Users" />

      {/* show list  */}
      <div>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <Box p={2}>
              <div>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small">User Type</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={usertype}
                    label="User Type"
                    onChange={usertype_select_onchange}
                  >
                    <MenuItem value="manager">Manager</MenuItem>
                    <MenuItem value="fellow">Fellow</MenuItem>
                    <MenuItem value="anganwadi">Anganwadi</MenuItem>
                    <MenuItem value="school">School</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box p={2}>
              <h3>
                {filteredData.length} {usertype} user(s) found.
              </h3>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box p={2}>
              <MuiSearch
                searchText={searchText}
                searchTextOnChange={searchTextOnChange}
              />
            </Box>
          </Grid>
          {usertype === "manager" ? (
            <>
              <Grid item xs={3}>
                <Box p={2}>
                  <Button
                    onClick={create_user_button_click}
                    variant="contained"
                  >
                    Create New Manager
                  </Button>
                </Box>
              </Grid>
            </>
          ) : null}
        </Grid>

        <div></div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {filteredData.map((user, index) => (
              <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
                <Card sx={{ maxWidth: 345, height: 150 }}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: grey[500] }}>
                        {user.image ? (
                          <>
                            <UserImage src={user.image} />
                          </>
                        ) : (
                          user.username.substring(0, 2).toUpperCase()
                        )}
                      </Avatar>
                    }
                    action={
                      <>
                        <IconButton
                          id={index + 1.1}
                          onClick={(e) => handleVertMenuClick(e, user)}
                          aria-controls={openVertMenu ? { index } : undefined}
                          aria-expanded={openVertMenu ? "true" : undefined}
                          aria-haspopup="true"
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </>
                    }
                    title={
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => preview_user_button_click(user)}
                      >
                        {user.firstname + user.middlename + user.lastname
                          ? user.firstname + user.middlename + user.lastname
                          : "NA"}
                      </div>
                    }
                    subheader={
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => preview_user_button_click(user)}
                      >
                        <div>{user.userid ? user.userid : ""}</div>
                        <div>
                          {user.usertype ? user.usertype : ""},{" "}
                          {user.status ? user.status : ""}
                        </div>
                        <div>
                          {user.permanentaddress ? user.permanentaddress : ""}
                        </div>
                      </div>
                    }
                  />
                  {/* <CardMedia component="img" height="194" image={require("../../media/images/content.webp")} alt="content" />
                  <CardContent></CardContent> */}
                </Card>
              </Grid>
            ))}
            {usertype === "manager" ? (
              <Menu
                id={selectedUser._id}
                anchorEl={anchorEl}
                open={openVertMenu}
                onClose={handleVertMenuClose}
                MenuListProps={{
                  "aria-labelledby": "vert-button",
                }}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: "20ch",
                  },
                }}
              >
                <MenuItem
                  onClick={() => update_user_button_click(selectedUser)}
                >
                  Edit
                </MenuItem>
                {/* <MenuItem onClick={() => delete_user_button_click(selectedUser)}>Delete</MenuItem> */}
              </Menu>
            ) : null}
          </Grid>
        </Box>
      </div>

      {/* save modal */}
      <Dialog
        open={openModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={modal_cancle_button_click}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Create</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="userid"
                    label="User ID"
                    name="userid"
                    value={userid}
                    onChange={(e) => setUserid(e.target.value)}
                    autoComplete="userid"
                    disabled={false}
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                    autoFocus
                  />
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="firstname"
                    label="First Name"
                    name="firstname"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                    autoComplete="firstname"
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="middlename"
                    label="Middle Name"
                    name="middlename"
                    value={middlename}
                    onChange={(e) => setMiddlename(e.target.value)}
                    autoComplete="middlename"
                    disabled={false}
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                    autoFocus
                  />
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="lastname"
                    label="Last Name"
                    name="lastname"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    autoComplete="lastname"
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="guardianname"
                    label="Guardian Name"
                    name="guardianname"
                    value={guardianname}
                    onChange={(e) => setGuardianname(e.target.value)}
                    autoComplete="guardianname"
                    disabled={false}
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                    autoFocus
                  />
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="dob"
                    label="DD/MM/YYYY"
                    name="dob"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    autoComplete="dob"
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                  />
                </div>
              </Box>
            </Grid>

            {/* <Grid item xs={6}>
              <Box p={2}>
                <FormControl size="small">
                  <TextField
                    id="DateofBirth"
                    label="Date of Birth"
                    name="DateofBirth"
                    fullWidth
                    size="small"
                    margin="normal"
                    variant="outlined"
                    onClick={() => setShowDatePicker(true)}
                    value={dob ? dob.toLocaleDateString() : ""}
                    InputProps={{
                      endAdornment: (
                        <DatePicker
                          selected={dob}
                          onChange={handleDateChange}
                          dateFormat="dd/MM/yyyy"
                          isClearable
                          customInput={<TextField />}
                          popperModifiers={{
                            preventOverflow: {
                              enabled: true,
                            },
                            hide: {
                              enabled: false,
                            },
                          }}
                          popperClassName="datepicker-popper"
                        />
                      ),
                    }}
                    style={{
                      backgroundColor:
                        "white" ,
                      opacity: 1 ,
                    }}
                  />
                </FormControl>
              </Box>
            </Grid> */}
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="password"
                    label="Password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="password"
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                  />
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="contactnumber"
                    label="Contact Number"
                    name="contactnumber"
                    value={contactnumber}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const numericValue = inputValue.replace(/[^0-9]/g, "");
                      if (numericValue.length <= 10) {
                        setContactnumber(numericValue);
                      }
                    }}
                    autoComplete="contactnumber"
                    size="small"
                    margin="normal"
                    required
                    fullWidth
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="managertype">Manager Type</InputLabel>
                    <Select
                      labelId="managertype"
                      id="managertype"
                      value={managertype}
                      label="Manager Type"
                      onChange={managertype_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="manager">Manager</MenuItem>
                      <MenuItem value="crc">CRCC</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="gender">Gender</InputLabel>
                    <Select
                      labelId="gender"
                      id="gender"
                      value={gender}
                      label="Gender"
                      onChange={gender_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                      <MenuItem value="others">Prefer not say</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="qualification">Qualification</InputLabel>
                    <Select
                      labelId="qualification"
                      id="qualification"
                      value={qualification}
                      label="Qualification"
                      onChange={qualification_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="matriculate">Matriculate</MenuItem>
                      <MenuItem value="intermediate">Intermediate</MenuItem>
                      <MenuItem value="graduate">Graduate</MenuItem>
                      <MenuItem value="masters">Post graduate</MenuItem>
                      <MenuItem value="doctorate">Doctorate</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="state">State</InputLabel>
                    <Select
                      labelId="state"
                      id="state"
                      value={state}
                      label="State"
                      onChange={state_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="20">Odisha</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="district">District</InputLabel>
                    <Select
                      labelId="district"
                      id="district"
                      value={district}
                      label="District"
                      onChange={district_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {districts.map((district) => (
                        <MenuItem key={district._id} value={district._id}>
                          {toTitleCase(district.districtname)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="block">Block</InputLabel>
                    <Select
                      labelId="block"
                      id="block"
                      value={block}
                      label="Block"
                      onChange={block_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {blocks.map((block) => (
                        <MenuItem key={block._id} value={block._id}>
                          {toTitleCase(block.blockname)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={modal_cancle_button_click}>Cancel</Button>
          <Button onClick={modal_save_button_click}>Save</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showUpdate} onClose={handleCloseUpdate}>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="userid"
                    label="User ID(not editable)"
                    // name="userid"
                    value={updateData.userid}
                    // onChange={(e) => setUserid(e.target.value)}
                    onChange={(e) =>
                      setUserid({
                        ...updateData,
                        userid: e.target.value,
                      })
                    }
                    // autoComplete="userid"
                    // disabled={false}
                    // size="small"
                    // margin="normal"
                    // required
                    // fullWidth
                    // autoFocus
                  />
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="firstname"
                    label="First Name"
                    // name="firstname"
                    value={updateData.firstname}
                    // onChange={(e) => setFirstname(e.target.value)}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        firstname: e.target.value,
                      })
                    }
                    // autoComplete="firstname"
                    // size="small"
                    // margin="normal"
                    // required
                    // fullWidth
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="middlename"
                    label="Middle Name"
                    // name="middlename"
                    value={updateData.middlename}
                    // onChange={(e) => setMiddlename(e.target.value)}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        middlename: e.target.value,
                      })
                    }
                    // autoComplete="middlename"
                    // disabled={false}
                    // size="small"
                    // margin="normal"
                    // required
                    // fullWidth
                    // autoFocus
                  />
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="lastname"
                    label="Last Name"
                    // name="lastname"
                    value={updateData.lastname}
                    // onChange={(e) => setLastname(e.target.value)}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        lastname: e.target.value,
                      })
                    }
                    // autoComplete="lastname"
                    // size="small"
                    // margin="normal"
                    // required
                    // fullWidth
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="guardianname"
                    label="Guardian Name"
                    // name="guardianname"
                    value={updateData.guardianname}
                    // onChange={(e) => setGuardianname(e.target.value)}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        guardianname: e.target.value,
                      })
                    }
                    // autoComplete="guardianname"
                    // disabled={false}
                    // size="small"
                    // margin="normal"
                    // required
                    // fullWidth
                    // autoFocus
                  />
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="dob"
                    label="DD/MM/YYYY"
                    // name="dob"
                    value={updateData.dob}
                    // onChange={(e) => setDob(e.target.value)}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        dob: e.target.value,
                      })
                    }
                    // autoComplete="dob"
                    // size="small"
                    // margin="normal"
                    // required
                    // fullWidth
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="password"
                    label="Password"
                    // name="password"
                    value={updateData.password}
                    // onChange={(e) => setPassword(e.target.value)}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        password: e.target.value,
                      })
                    }
                    // autoComplete="password"
                    // size="small"
                    // margin="normal"
                    // required
                    // fullWidth
                  />
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <TextField
                    id="contactnumber"
                    label="Contact Number"
                    // name="contactnumber"
                    value={updateData.contactnumber}
                    // onChange={(e) => {
                    //   const inputValue = e.target.value;
                    //   const numericValue = inputValue.replace(/[^0-9]/g, "");
                    //   if (numericValue.length <= 10) {
                    //     setContactnumber(numericValue);
                    //   }
                    // }}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        contactnumber: e.target.value,
                      })
                    }
                    // autoComplete="contactnumber"
                    // size="small"
                    // margin="normal"
                    // required
                    // fullWidth
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="gender">Gender</InputLabel>
                    <Select
                      labelId="gender"
                      id="gender"
                      value={updateData.gender}
                      label="Gender"
                      // onChange={gender_select_onchange}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          gender: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                      <MenuItem value="others">Prefer not say</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="qualification">Qualification</InputLabel>
                    <Select
                      labelId="qualification"
                      id="qualification"
                      value={updateData.qualification}
                      label="Qualification"
                      // onChange={qualification_select_onchange}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          qualification: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="matriculate">Matriculate</MenuItem>
                      <MenuItem value="intermediate">Intermediate</MenuItem>
                      <MenuItem value="graduate">Graduate</MenuItem>
                      <MenuItem value="masters">Post graduate</MenuItem>
                      <MenuItem value="doctorate">Doctorate</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            {/* <Grid item xs={6}>
              <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="qualification">Qualification</InputLabel>
                    <Select
                      labelId="qualification"
                      id="qualification"
                      value={updateData.qualification}
                      label="Qualification"
                      onChange={qualification_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="matriculate">Matriculate</MenuItem>
                      <MenuItem value="intermediate">Intermediate</MenuItem>
                      <MenuItem value="graduate">Graduate</MenuItem>
                      <MenuItem value="masters">Post graduate</MenuItem>
                      <MenuItem value="doctorate">Doctorate</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Grid> */}
            <Grid item xs={6}>
              {/* <Box p={2}>
                <div>
                  <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="state">State</InputLabel>
                    <Select
                      labelId="state"
                      id="state"
                      value={updateData.stateid}
                      label="State"
                      // onChange={state_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="20">Odisha</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Box> */}
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}></Grid>
            <Grid item xs={6}>
              <Box p={2}>
                <div>
                  {/* <FormControl
                    sx={{ m: 1, minWidth: 120, width: "100%" }}
                    size="small"
                  >
                    <InputLabel id="block">Block</InputLabel>
                    <Select
                      labelId="block"
                      id="block"
                      value={updateData.blockname}
                      label="Block"
                      onChange={block_select_onchange}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {blocks.map((block) => (
                        <MenuItem key={block._id} value={block._id}>
                          {toTitleCase(block.blockname)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                  <Button
                    variant="outlined"
                    style={{ marginLeft: 12 }}
                    onClick={handleCloseUpdate}
                  >
                    Close
                  </Button>
                  <Button variant="contained" onClick={handleUpdateChanges}>
                    Update
                  </Button>
                </div>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
}

export default UsersPage;
